/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import { FeatureFlags } from './FeatureFlags';
import { reducer } from './redux/reducer';

@Crate({
  imports: [
    HttpCrate,
  ],
  name: 'FeatureFlagsCrate',
  reducers: {
    featureFlags: reducer,
  },
  services: [
    { name: 'featureFlags', provide: FeatureFlags },
  ],
})

export class FeatureFlagsCrate {}
